document.addEventListener("DOMContentLoaded", () => {
  const initAjaxinate = () => {
    if (typeof Ajaxinate === "undefined") return;
    const container = document.querySelector("#AjaxinateBlog");
    const pagination = document.querySelector("#AjaxinatePaginationBlog");
    if (!container || !pagination) return;

    new Ajaxinate({
      container: "#AjaxinateBlog",
      pagination: "#AjaxinatePaginationBlog",
      loadingText: "Loading...",
      offset: 100,
      method: "click",
    });
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(initAjaxinate, { timeout: 500 });
  } else {
    setTimeout(initAjaxinate, 250);
  }

  document.querySelectorAll("[data-menu-toggle]").forEach((toggle) => {
    toggle.addEventListener("click", (event) => {
      const wrapper = event.currentTarget.closest("[data-menu]");
      if (wrapper) {
        wrapper.classList.toggle("is-open");
      }
    });
  });
});
